export const reduxKey = '@@EarningsCalculator';
